
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from './hooks/useAuth';

// Import pages
import Index from './pages/Index';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import Teams from './pages/Teams';
import Cockpit from './pages/Cockpit';
import PageSpeed from './pages/PageSpeed';
import WorkforcePlanning from './pages/WorkforcePlanning';
import ProjectTeam from './pages/ProjectTeam';
import ProjectSkills from './pages/ProjectSkills';
import TeamProjects from './pages/TeamProjects';
import NotFound from './pages/NotFound';
import Analytics from './pages/Analytics';
import Billing from './pages/Billing';
import HRChatbot from './pages/HRChatbot';
import TeamMatching from './pages/TeamMatching';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Developer from './pages/Developer';
import Integrations from './pages/Integrations';
import Notifications from './pages/Notifications';
import ESGDashboard from './pages/ESGDashboard';

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/project/:id/dashboard" element={<Dashboard />} />
            <Route path="/project/:id/overview" element={<Dashboard />} />
            <Route path="/project/:id/team" element={<ProjectTeam />} />
            <Route path="/project/:id/cockpit" element={<Cockpit />} />
            <Route path="/pagespeed" element={<PageSpeed />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/project/:id/pagespeed" element={<PageSpeed />} />
            <Route path="/project/:id/workforce" element={<WorkforcePlanning />} />
            <Route path="/project/:id/hr-chatbot" element={<HRChatbot />} />
            <Route path="/teams/:teamId/projects" element={<TeamProjects />} />
            <Route path="/teams/:teamId/projects/:projectId/team" element={<ProjectTeam />} />
            <Route path="/teams/:teamId/projects/:projectId/skills" element={<ProjectSkills />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/esg-dashboard" element={<ESGDashboard />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/hr-chatbot" element={<HRChatbot />} />
            <Route path="/hr-chatbot" element={<HRChatbot />} />
            <Route path="/team-matching" element={<TeamMatching />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/project/1/settings" element={<Settings />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/developer" element={<Developer />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
